import { useCallback, useState } from 'react';

// Which Application Details fields (Notes/Water rate/Target) are shown for
// each task, keyed `${taskId}:${field}` — an override falling back to a
// data-driven default (the field has a value, or for Water rate a liquid
// input), reset on input switch (OP-2125). Each field's own button shows and
// hides it; there is no separate whole-card toggle any more (OP-2534).
export const useTaskDetailsVisibility = () => {
  const [fieldVisibilityOverride, setFieldVisibilityOverride] = useState<
    Map<string, boolean>
  >(new Map());

  const setFieldVisible = useCallback(
    (taskId: string, field: string, visible: boolean) => {
      setFieldVisibilityOverride((previous) => {
        const next = new Map(previous);
        next.set(`${taskId}:${field}`, visible);
        return next;
      });
    },
    []
  );

  const reset = useCallback(() => {
    setFieldVisibilityOverride(new Map());
  }, []);

  return { fieldVisibilityOverride, setFieldVisible, reset };
};
